import { useHistory, useLocation } from 'react-router-dom'

export const useDockData = () => {
  const history = useHistory()
  const location = useLocation()

  const currentDock = localStorage.currentDock && JSON.parse(localStorage.currentDock)

  if (!currentDock) {
    history.push(`/dock-assign?next=${location.pathname}`)
  }

  return currentDock;
}
